<template>
  <div class="chat-library-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="addContent('add')">+新增聊天内容</el-button>
      <el-button type="primary" size="small" @click="batchShield(idList)">批量删除</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" :row-key="getRowKeys" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" fixed disabled='true' :selectable="selectable" :reserve-selection="true"></el-table-column>
      <el-table-column prop="id" label="ID" align="center">
        <template slot-scope="scope">
          {{scope.row.id || '未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="robotType" label="机器人类型" align="center" >
        <template slot-scope="scope">
          {{scope.row.robotType === 'COMMENT' ? '评论机器人' : '影院机器人'}}
        </template>
      </el-table-column>

      <el-table-column prop="content" label="聊天内容" align="center" >
        <template slot-scope="scope">
          {{scope.row.content || '暂无'}}
        </template>
      </el-table-column>
     
      <el-table-column prop="createdAt" label="创建时间" align="center" >
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove([scope.row.id])"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="param.pageNumber" :page-size="param.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <add-content ref="addContent" @handlerContent="getContentList('status')"></add-content>
  </div>
</template>
<script>
import API from '@/api'
import addContent from './components/addContent'
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: '',
      // 批量选择内容ID
      idList: [],
      param: {
        pageNumber: 1,
        pageSize: 10,
        robotType: ''
      }
    }
  },
  components: {
    addContent
  },
  created() {
    this.getContentList()
  },
  methods: {
    // 请求聊天内容列表
    getContentList() {
      this.loading = true
      API.getContentList(this.param).then(res => {
        if (res.code === 200 && res.data.list.length > 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 禁止选择勾选框
    selectable(row) {
      if (row.isDelete) {
        return false
      } else {
        return true
      }
    },
    // 批量删除
    batchShield(idList) {
      if (idList.length === 0) {
        this.$message.error('至少选择一条数据进行操作');
        return false
      }

      this.remove(idList)
    },
    // 获取批量操作数据id
    handleSelectionChange(row) {
      var arr = [];
      row.forEach(function (item) {
        arr.push(item.id)
      })
      this.idList = arr
    },
    getRowKeys(row) {
      return row.id;
    },

     // 删除聊天内容
    remove(idList) {
      this.$confirm('您确定要删除当前聊天内容吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delContent({ids:idList}).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除内容成功',
                type: 'success'
              })
              this.getContentList()
            } else {
              this.$message.error('删除内容失败')
            }
          })
        })
        .catch(() => { });
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size
      this.param.pageNumber = 1
      this.getContentList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber
      this.getContentList()
    },
    // 打开编辑、添加弹窗
    addContent(type) {
      this.$refs.addContent.open(type)
    }
  }
}
</script>
<style lang="scss">

</style>